import React, { useState, useEffect, useRef, forwardRef } from 'react';
import ProgressBar from "@ramonak/react-progress-bar";
import QualificationQuestion from '../form/QualificationQuestion';
import Booking from '../booking/Booking';
import { Images } from '../../constants';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { Confirm } from '../button';
import { useTranslation } from 'react-i18next';
import Preview from '../booking/share/Preview';

const RightContent = forwardRef((props, ref) => {
  const {
    isLoadingTiming,
    loadingTimingPercentage,
    color,
    data,
    timezone,
    timezoneName,
    countryCode,
    timingsData,
    type,
    locationSearch,
    isReschedule,
    isCancelMeeting,
    meetingId,
    setBackToReschedule,
    timingPath,
    setNewTimingPath,
    removeBranding,
    removeTimeslot,
    handleChangeTimezone,
    handleCancelMeetingButton,
    dateSelected,
    handleDateSelected,
    handleTimingSelected,
    timingSelected,
    setHandleLeftBackButton,
    handleShowTimingSelected,
    cancelMeeting,
    isConfirm,
    showTimingList,
    handleShowTimingList,
    showForm,
    handleShowForm,
    languageCode,
    userTeamPathId,
    typeUser,
    locationOptions,
    isShareDateTime,
    shareTimings,
    datesSelected,
    timeSlots,
    showButtonConfirm,
    handleConfirmButton,
    title,
    location,
    timeInterval,
    isoTime,
    meetingLinkPath,
    currentDuration,
    scheduleLocation
  } = props;

  const [ isQualification, setIsQualification ] = useState(false);
  const [ showBooking, setShowBooking ] = useState(false);
  const [ redirectStatus, setRedirectStatus ] = useState(false);
  const [ redirectLink, setRedirectLink ] = useState('');
  const [ isBackBookingPage, setIsBackBookingPage ] = useState(false);
  const { width } = useWindowDimensions();
  const [ confirmTypeButton, setConfirmTypeButton ] = useState('button');
  const [ linkOptionQUalification, setLinkOptionQualification ] = useState(null);
  const [ disableConfirmButton, setDisableConfirmButton ] = useState(true);

  const showFormRef = useRef(); // to show form field
  const handleFormSubmitRef = useRef(); // for submitting the form
  const answerOptionRef = useRef(); // to handle confirm button for options in qualification
  const { t } = useTranslation();
  const [ showPreviewShareEmail, setShowPreviewShareEmail ] = useState(false);

  useEffect(() => {
    if(width <= 858) {
      handleConfirmButton(true);
    }
  },
  // eslint-disable-next-line
  [width, isQualification]);

  useEffect(() => {
    if(data['current_page']==="booking_page" || data['reschedule_url']){
      setRedirectStatus(data.redirect_status);
      setRedirectLink(data.redirect_link);
      setShowBooking(true);
    }
    else if(data['current_page']==="question"){
      if(data['question']['action_type']==="question"){
        setIsQualification(true);
      } 
      else if(data['question']['action_type']==="booking_page"){
        setIsBackBookingPage(true);
        setShowBooking(true);
      }
    }
  }, [data]);

  useEffect(() => {
    if(showBooking){
      setIsQualification(false);
    }
    else{
      setIsQualification(true);
    }
  }, [showBooking]);

  useEffect(() => {
    if(showTimingList){
      setConfirmTypeButton('button');
      setDisableConfirmButton(true);
    }
  }, 
  // eslint-disable-next-line
  [showTimingList]);

  useEffect(() => {
    if (isQualification) {
      if (linkOptionQUalification) {
        setDisableConfirmButton(false);
      }
      else {
        setDisableConfirmButton(true);
      }
    }
    else if (isCancelMeeting) {
      setDisableConfirmButton(false);
    }
    else if ((dateSelected && !showTimingList) || (showTimingList && (timingSelected || isShareDateTime))) {
      setDisableConfirmButton(false);
    }
  },
  [dateSelected, timingSelected, isCancelMeeting, showTimingList, isQualification, linkOptionQUalification, isShareDateTime]);

  const confirmButtonOnClick = async (event) => {
    if(showForm && handleFormSubmitRef.current !== null){
      setConfirmTypeButton('submit');
    }
    else if (isQualification) {
      answerOptionRef.current.goTo(linkOptionQUalification);
    }
    else{
      setConfirmTypeButton('button');
      handleShowTimingSelected(true);
      showFormRef.current.nextShowComponent();
    }
  };


  useEffect(() => {
    if (showPreviewShareEmail) {
      handleShowTimingList(false);
    }
  },
  // eslint-disable-next-line
  [showPreviewShareEmail])

  const handleClickedOptionQualification = (link) => {
    if (link) {
      setLinkOptionQualification(link);
    }
  };

  const showPreviewShare = () => {
    setShowPreviewShareEmail(true);
    handleShowTimingList(false);
    setDisableConfirmButton(false);
  }

  const backFromShowPreview = () => {
    setShowBooking(true);
    setShowPreviewShareEmail(false);
    handleShowTimingList(false);
  }

  if(!data) return null;
  return(
    <>
      <div 
        className="right-content" 
        // style={{height: ((width <= 858) && showButtonConfirm && {height: '100vh'}) ? 'calc(100vh - 11rem)' : '100vh'}} \
        id="right-content"
        style={ isShareDateTime ? { width: '100%' } : {} }>

        <div className="progress-bar-wrap">
          {isLoadingTiming && (
            <ProgressBar 
              completed={loadingTimingPercentage} 
              bgColor={color} 
              baseBgColor={'#fdfdfd'} 
              isLabelVisible={false} 
              borderRadius={'5px'} 
              height={'5px'} />
          )}
        </div>

        { !isReschedule && !isCancelMeeting && isQualification && (
          <QualificationQuestion
            backButtonRef={ref}
            question={data['question']}
            uid={data['uid']}
            color={color}
            locationSearch={locationSearch}
            userTeamPathId={userTeamPathId}
            typeUser={typeUser}
            answerOptionRef={answerOptionRef}
            handleClickedOptionQualification={handleClickedOptionQualification} />
        )}

        { (showBooking) && (
          <Booking
            ref={showFormRef}
            backButtonRef={ref}
            color={color}
            data={data}
            locationSearch={locationSearch}
            timezone={timezone}
            timezoneName={timezoneName}
            countryCode={countryCode}
            type={type}
            timingsData={timingsData}
            redirectStatus={redirectStatus}
            redirectLink={redirectLink}
            isBackBookingPage={isBackBookingPage}
            isReschedule={isReschedule}
            meetingId={meetingId}
            isCancelMeeting={isCancelMeeting}
            setBackToReschedule={setBackToReschedule}
            timingPath={timingPath}
            getTimings={setNewTimingPath}
            removeTimeslot={removeTimeslot}
            handleChangeTimezone={handleChangeTimezone}
            handleCancelMeetingButton={handleCancelMeetingButton}
            handleTimingSelected={handleTimingSelected}
            dateSelected={dateSelected}
            handleDateSelected={handleDateSelected}
            timingSelected={timingSelected}
            setHandleLeftBackButton={setHandleLeftBackButton}
            handleConfirmButton={handleConfirmButton}
            handleShowTimingSelected={handleShowTimingSelected}
            cancelMeeting={cancelMeeting}
            showTimingList={showTimingList}
            handleShowTimingList={handleShowTimingList}
            showForm={showForm}
            handleShowForm={handleShowForm}
            handleFormSubmitRef={handleFormSubmitRef}
            languageCode={languageCode}
            userTeamPathId={userTeamPathId}
            typeUser={typeUser}
            locationOptions={locationOptions}
            isShareDateTime={isShareDateTime}
            shareTimings={shareTimings}
            timeSlots={timeSlots}
            datesSelected={datesSelected}
            showPreviewShare={showPreviewShare}
            showPreviewShareEmail={showPreviewShareEmail}
            currentDuration={currentDuration}
            scheduleLocation={scheduleLocation} />
        )}

        { ((isReschedule || isCancelMeeting) && !isConfirm && width > 858) && (
          <div className="cancel-meeting-wrap">
            <div className="cancel-button">
              <button style={{ color: color }} onClick={() => cancelMeeting(true, false)}>{t('Cancel Meeting')}</button>
            </div>
          </div>
        )}

        {/* ------------------------------ Footer -----------------------------*/}
        { !isShareDateTime && (
          <div 
            className="right-footer" 
            style={{ 
              position: ( width <= 858 && (showButtonConfirm)) ? 'relative' : '', 
              bottom: ((width <= 858) && showButtonConfirm) ? '1.5rem' : 'unset',
              top: '0',
              marginBottom: (showButtonConfirm && !removeBranding) ? '6rem' : '2rem',
              backgroundColor: removeBranding && 'transparent' }} >
            { !removeBranding && (
              <>
                <p className="footer-text">
                  {t('Powered by')}
                </p>
                <a href={process.env.REACT_APP_WEB_URL} target={'_blank'} rel="noopener">
                  <img alt="novocall-icon" width="75" height="15" className="right-footer-icon" src={Images.novocallLogo} />
                </a>
              </>
            )}
          </div>
        )}
        

        { showButtonConfirm && (
          <Confirm 
            confirmButtonOnClick={confirmButtonOnClick}
            color={color}
            type={confirmTypeButton}
            disabled={disableConfirmButton && !showPreviewShareEmail}
            showCancelButton={((isReschedule || isCancelMeeting) && !isConfirm) && (width <= 858)}
            cancelMeeting={cancelMeeting}
            isShareDateTime={isShareDateTime}
            isShowTimingList={showTimingList}
            shareTimings={shareTimings}
            dateSelected={dateSelected}
            showPreviewShare={showPreviewShare}
            previewShare={showPreviewShareEmail}
            backFromShowPreview={backFromShowPreview} />
        )}

        {showPreviewShareEmail && (
          <Preview 
            color={color} 
            onClickBack={backFromShowPreview}
            title={title}
            location={location}
            timeInterval={timeInterval}
            timezone={timezoneName}
            shareTimings={shareTimings}
            isoTime={isoTime}
            meetingId={meetingId}
            meetingLinkPath={meetingLinkPath} />
        )}
      </div>

      
      {/* <div className="right-footer" style={removeBranding ? {visibility:'hidden'} : {}}>
          <a href="https://novocall.co/">
              Powered by <img alt="novocall-icon" className="right-footer-icon" src={Images.novocallLogo} />
          </a>
        </div> */}
    </>
  );
});

export default RightContent;